import React from 'react';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import commonS from 'styles/common.module.less';
import { Event } from 'types/calendar';
import s from './s.module.less';
import type { NotificationInstance } from 'antd/es/notification/interface';
import { KlarityService, Prospect } from 'types/common';
import Content from '../index';

type Props = {
    onCancel: () => void
    event?: Event //for edit fun
    onSuccess?: () => void
    currentChannelId?: number,
    prospect?: Prospect,
    defaultStart?: dayjs.Dayjs,
    defaultEnd?: dayjs.Dayjs,
    timezone?: string,
    allSpecialityData?: KlarityService[],
};

const AddAndEditCalendarEventModal = (props: Props) => {
    const { onCancel, event, onSuccess, defaultStart, defaultEnd, timezone, allSpecialityData } = props;

    return (
        <Modal
            closable
            className={commonS.modalFixHeightMaxWrap}
            width="600px"
            destroyOnClose
            onCancel={onCancel}
            okText="Save"
            open
            wrapClassName={s.modalWrap}
            closeIcon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 18L18 6M6 6L18 18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>}
            footer={null}
        >
            <Content
                event={event}
                onCancel={onCancel}
                onSuccess={onSuccess}
                defaultStart={defaultStart}
                defaultEnd={defaultEnd}
                timezone={timezone}
                allSpecialityData={allSpecialityData}
            />
        </Modal>
    );
};

export default AddAndEditCalendarEventModal;
